import React from "react";
import { MoreLabelBox } from "@icoach/components";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { PEOPLE_TYPE } from "@icoach/constants/";

const SmartFitnessBandMoreLabel = ({ rowsData, handleOpenDialog, dialogRef, refresh, handleSendSMSClick, ...props }) => {
	const { memberID, displayName, nickName, deviceOrderID, effectID } = rowsData;

	const moreLabelMap = {
		view: {
			text: "查看",
			to: () => CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_DETAIL_MAIN_PATH(deviceOrderID),
		},
		editCreditCard: {
			text: "變更信用卡",
			onClickEvent: () => dialogRef?.current?.openSmartFitnessBandEditCreditCardDialog?.({ ...rowsData, memberName: rowsData.displayName }, refresh),
		},
		quit: {
			text: "退訂",
			to: () => CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_QUIT_PATH(deviceOrderID),
		},
		quitDelete: {
			text: "取消退訂",
			onClickEvent: () => dialogRef?.current?.openSmartFitnessBandQuitDeleteDialog?.({ effectID }, refresh),
		},
		delete: {
			text: "刪除",
			onClickEvent: () => dialogRef.current && dialogRef.current.openSmartFitnessBandDeleteContractDialog({ deviceOrderID, displayName, nickName }, refresh),
		},
		sms: {
			text: "簡訊",
			onClickEvent: () =>
				dialogRef.current &&
				dialogRef.current.openSendSmsDialog(
					{
						id: memberID,
						type: PEOPLE_TYPE.MEMBER,
						name: nickName,
					},
					refresh
				),
		},
	};

	return <MoreLabelBox {...props} id={rowsData.cabinetID} moreLabelMap={moreLabelMap} textAlign="center" />;
};

export default SmartFitnessBandMoreLabel;
